import wx from "weixin-js-sdk";
import  request from "./request"

class SDK {
    wx = {};
    init() {
        if (Object.keys(this.wx).length > 0) {
            return Promise.resolve(wx);
        } else {
            return request.postJson("/api/wechat/jssdk/config/get", {
                    tenantId: $config.tenantId,
                    weChatId: $config.weChatId,
                    jsApiList: [
                        "updateAppMessageShareData",
                        "updateTimelineShareData",
                        "onMenuShareTimeline",
                        "onMenuShareAppMessage",
                        "onMenuShareQQ",
                        "onMenuShareWeibo",
                        "scanQRCode",
                        "chooseImage",
                        "previewImage",
                        "uploadImage",
                        "downloadImage",
                        "hideAllNonBaseMenuItem",
                        "checkJsApi",
                        "hideMenuItems",
                        "showMenuItems",
                        "getLocation",
                        "openLocation"
                    ],
                    url: window.location.href.split('#')[0],
                    onDebug: 0
                })
                .then(data => {
                    return new Promise((resolve, reject) => {
                        wx.config({
                            debug: false,
                            appId: data.content.wxAppId,
                            timestamp: data.content.timestamp,
                            nonceStr: data.content.nonceStr,
                            signature: data.content.signature,
                            jsApiList: [
                                "updateAppMessageShareData",
                                "updateTimelineShareData",
                                "onMenuShareTimeline",
                                "onMenuShareAppMessage",
                                "onMenuShareQQ",
                                "onMenuShareWeibo",
                                "scanQRCode",
                                "chooseImage",
                                "previewImage",
                                "uploadImage",
                                "downloadImage",
                                "hideAllNonBaseMenuItem",
                                "checkJsApi",
                                "hideMenuItems",
                                "showMenuItems",
                                "getLocation",
                                "openLocation"
                            ]
                        });
                        wx.ready(() => {
                            this.wx = wx;
                            resolve(wx);
                        });
                        wx.error(res => {
                            reject(res);
                        });
                    });
                });
        }
    }
}
const wxSDK = new SDK();
export default wxSDK;
